import { OnChanges, HostListener } from '@angular/core';
import { Component, ElementRef, OnInit, ViewEncapsulation, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { AgGridColumn } from '@hub/models/AgGridColumn.model';
import { PageLoaderService } from "app/services/index";
import { AGCheckBoxEditorComponent } from './grid-components/g-checkbox/g-checkbox-editor.component';
import { AGCheckBoxRendererComponent } from './grid-components/g-checkbox/g-checkbox-renderer.component';
import { AGCurrencyRendererComponent } from './grid-components/g-currency/g-currency.component';
import { AGDatepickerEditorComponent } from './grid-components/g-datepicker/g-datepicker.component';
import { AGDeleteButtonComponent } from './grid-components/g-delete-button/g-delete-button.component';
import { AGDropdownEditorComponent } from './grid-components/g-dropdown/g-dropdown.component';
import { AGHyperlinkComponent } from './grid-components/g-hyperlink/g-hyperlink.component';
import { AGInputEditorComponent } from './grid-components/g-input/g-input.component';
import { AGTextAreaEditorComponent } from './grid-components/g-textarea/g-textarea.component';

@Component({
  selector: 'subgrid-v2',
  templateUrl: 'subgrid.component.html',
  styleUrls: ['./subgrid.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubgridV2Component implements OnInit, OnDestroy, OnChanges {
  private static readonly inputEditorKey = 'numericEditor';
  private static readonly dropdownEditorKey = 'dropdownEditor';
  private static readonly datepickerEditorKey = 'datepickerEditor';
  private static readonly checkboxEditorKey = 'checkboxEditor';
  private static readonly textareaEditorKey = 'textareaEditor';
  private static readonly checkboxRendererKey = 'checkboxRenderer';
  private static readonly deleteButtonRendererKey = 'deleteButtonRenderer';
  private static readonly hyperlinkRendererKey = 'hyperlinkRenderer';
  private static readonly currencyRendererKey = 'currencyRenderer';

  public gridApi;
  public gridColumnApi;
  public columnDefs = [];
  public rowData;
  public defaultColDef;
  public frameworkComponents;
  public paginationPageSize;

  public rowSelection;
  public params: any;
  public rowHeight: string = "32";
  private gridWidth: number = 0;
  private totalGridColumns: number = 0;
  public wrapperWidth: any;



  @Input() gridSettings: AgGridColumn[] = [];
  @Input() gridData: any;
  @Input() isButton;
  @Input() newData: any;
  @Input() gridNo: number;

  @Output() gridColumnSettings: EventEmitter<any> = new EventEmitter();
  @Output() saveRowData: EventEmitter<any> = new EventEmitter();


  constructor(
    private hostElement: ElementRef<HTMLElement>,
    protected pageLoaderService: PageLoaderService,

  ) {
    this.frameworkComponents = {
      [SubgridV2Component.inputEditorKey]: AGInputEditorComponent,
      [SubgridV2Component.dropdownEditorKey]: AGDropdownEditorComponent,
      [SubgridV2Component.datepickerEditorKey]: AGDatepickerEditorComponent,
      [SubgridV2Component.checkboxEditorKey]: AGCheckBoxEditorComponent,
      [SubgridV2Component.textareaEditorKey]: AGTextAreaEditorComponent,
      [SubgridV2Component.checkboxRendererKey]: AGCheckBoxRendererComponent,
      [SubgridV2Component.deleteButtonRendererKey]: AGDeleteButtonComponent,
      [SubgridV2Component.hyperlinkRendererKey]: AGHyperlinkComponent,
      [SubgridV2Component.currencyRendererKey]: AGCurrencyRendererComponent,
    };


    this.defaultColDef = {
      sortable: true,
      resizable: true,
      filter: false,
      cellClassRules: {
        'non-editable-class': function (params) { return !params.colDef.editable },
        'editable-class': function (params) { return params.colDef.editable },
      },
      domLayout: 'autoHeight',
    }



    this.rowSelection = "single";
    this.paginationPageSize = 10;

  }

  isLeftShow: boolean = false;
  isRightShow: boolean = false;

  ngOnInit() {
    this.updateColumnDefs();
    this.rowData = this.gridData;
  }


  ngOnDestroy() {
    this.gridColumnsChanged();

    var data = this.getRowData();
  }

  ngOnChanges(){
    this.updateColumnDefs();
    this.rowData = this.gridData;

  }

  private updateColumnDefs() {
    this.columnDefs = (this.gridSettings || []).map(column => this.normalizeColumnDef(column));
  }

  private normalizeColumnDef(column: AgGridColumn): AgGridColumn {
    return {
      ...column,
      cellEditor: this.normalizeEditor(column.cellEditor),
      cellRenderer: this.normalizeRenderer(column.cellRenderer),
    };
  }

  private normalizeEditor(editor?: string): string {
    switch (editor) {
      case 'numeric-cell':
      case 'AGInputEditorComponent':
      case SubgridV2Component.inputEditorKey:
        return SubgridV2Component.inputEditorKey;
      case 'dropdown-cell':
      case 'AGDropdownEditorComponent':
      case SubgridV2Component.dropdownEditorKey:
        return SubgridV2Component.dropdownEditorKey;
      case 'datepicker-cell':
      case 'AGDatepickerEditorComponent':
      case SubgridV2Component.datepickerEditorKey:
        return SubgridV2Component.datepickerEditorKey;
      case 'checkbox-cell':
      case 'AGCheckBoxEditorComponent':
      case SubgridV2Component.checkboxEditorKey:
        return SubgridV2Component.checkboxEditorKey;
      case 'textarea-cell':
      case 'AGTextAreaEditorComponent':
      case SubgridV2Component.textareaEditorKey:
        return SubgridV2Component.textareaEditorKey;
      default:
        return editor;
    }
  }

  private normalizeRenderer(renderer?: any): any {
    switch (renderer) {
      case 'checkbox-cell':
      case 'AGCheckBoxRendererComponent':
      case SubgridV2Component.checkboxRendererKey:
        return SubgridV2Component.checkboxRendererKey;
      case 'delete-button':
      case 'AGDeleteButtonComponent':
      case SubgridV2Component.deleteButtonRendererKey:
        return SubgridV2Component.deleteButtonRendererKey;
      case 'hyperlinkRenderer':
      case 'AGHyperlinkComponent':
      case SubgridV2Component.hyperlinkRendererKey:
        return SubgridV2Component.hyperlinkRendererKey;
      case 'currencyRenderer':
      case 'AGCurrencyRendererComponent':
      case SubgridV2Component.currencyRendererKey:
        return SubgridV2Component.currencyRendererKey;
      default:
        return renderer;
    }
  }

// for adding new row
  onAddRow() {
    if(this.gridApi){
      // var newItem = this.gridData[this.gridData.length-1];
      var newItem = this.createNewRowData();
      this.gridApi.applyTransaction({ add: [newItem] });
    }

  }

  createNewRowData(){
    let item ={};
    return item;
  }

//for removal of row
  onRemoveSelected() {
    var selectedData = this.gridApi.getSelectedRows();
    this.gridApi.applyTransaction({ remove: selectedData });
  }

  getRowData() {
    let rowData = [];
    rowData = this.gridData;
    return rowData;
  }

  ngAfterViewInit() {
    var wrapper = this.getGridElement("ag-root-wrapper-body");

    if (!wrapper) {
      return;
    }

    this.wrapperWidth = wrapper.clientWidth;
  }

  gridColumnsChanged() {
    var gridColumns = this.gridColumnApi ? this.gridColumnApi.getAllGridColumns() || [] : [];
    var displayedColumns = this.gridColumnApi ? this.gridColumnApi.getAllDisplayedColumns() || [] : [];

    var columnSettings = this.columnDefs;

    columnSettings.forEach(x => {
      var filterData = gridColumns.filter(y => y.colId == x.field)[0];
      if (filterData) {
        x.hide = !filterData.isVisible();
        x.sort = filterData.getSort() == undefined ? null : filterData.getSort();
        x.pinned = filterData.getPinned();
        x.width = filterData.getActualWidth();
      }

      var sortData = displayedColumns.filter(y => y.colId == x.field)[0];
      x.order = sortData ? displayedColumns.indexOf(sortData) + 1 : null;
    })
  }

  setHiddenColumns(data: any) {
    this.gridColumnSettings.forEach(x => {
      var filterData = data.filter(y => y.colId == x.field);
      if (!filterData) {
        x.hide = true;
      }
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.columnDefs.forEach(data => {
      if (data && data.headerName) {
        this.gridWidth += data.IsHidden ? 0 : data.width
        this.totalGridColumns++;
      }
    });
    if(this.gridWidth < this.wrapperWidth){
      this.gridApi.sizeColumnsToFit();
    }


  }

  onPageSizeChanged(event: any) {

  }

  onSelectionChanged(event){
    var selectedRows = this.gridApi.getSelectedRows();
  }

  onCellValueChanged(event){
   this.saveRowData.emit(event);
  }

  @HostListener("window:scroll", ["updateShadowPosition($event)"])
  updateShadowPosition(evt) {
    if (evt != undefined ) {
      this.setHeight(this.gridNo);
    }
  }

  onScroll(event: any) {
    if (event) {
      this.setHeight(this.gridNo);
      this.updateShadowState(event, this.gridNo);
    }
  }

  onViewPortChanged(event: any) {
    this.setHeight(this.gridNo);
  }

  onDragStarted(event: any) {
    this.isLeftShow = false;
    this.isRightShow = false;
  }

  onDragStopped(event: any) {
    this.onScroll(event);
  }

  onrowDataChanged(event: any) {
    this.showRightShadow(this.gridNo);
  }

  showRightShadow(gridNo: number) {
    var gridIndex = gridNo ? gridNo : 0;
    var wrapper = this.getGridElement("ag-root-wrapper-body", gridIndex);
    var body = this.getGridElement("ag-body-container", gridIndex);

    if (!wrapper || !body) {
      return;
    }

    var wrapperWidth = wrapper.clientWidth;
    var bodyWidth = body.clientWidth;
    var leftPinnedCol = this.getGridElements("ag-pinned-left-cols-viewport");
    var rightPinnedCol = this.getGridElements("ag-pinned-right-cols-viewport");
    var leftPinnedColWidth = 0;
    var rightPinnedColWidth = 0;

    if (leftPinnedCol) {
      var leftPinnedElement = leftPinnedCol[gridIndex] as HTMLElement;

      if (leftPinnedElement) {
        leftPinnedColWidth = leftPinnedElement.clientWidth;
      }
    }
    if (rightPinnedCol) {
      var rightPinnedElement = rightPinnedCol[gridIndex] as HTMLElement;

      if (rightPinnedElement) {
        rightPinnedColWidth = rightPinnedElement.clientWidth;
      }
    }

    var scrollableWidth = wrapperWidth - leftPinnedColWidth - rightPinnedColWidth;
    this.setHeight(gridNo);

      if (scrollableWidth < bodyWidth) {
        this.isRightShow = true;
      }
      else {
        this.isRightShow = false;
      }
  }

  updateShadowState(event: any, gridNo: number) {
    var gridIndex = gridNo ? gridNo : 0;
    var bodyViewport = this.getGridElement("ag-body-viewport", gridIndex);
    var body = this.getGridElement("ag-body-container", gridIndex);
    var horizontalOffset = event && typeof event.left === 'number' ? event.left : bodyViewport ? bodyViewport.scrollLeft : 0;

    if (!bodyViewport || !body) {
      return;
    }

    this.isLeftShow = horizontalOffset > 0;
    this.showRightShadow(gridNo);

    if (bodyViewport.clientWidth >= body.clientWidth) {
      this.isLeftShow = false;
    }
  }

  setLeftShadow(gridNo: number): string {
    var agWrapper =  this.getGridElements("ag-body");
    var leftPinnedElement = this.getGridElements("ag-pinned-left-cols-viewport");
    if (leftPinnedElement) {
      var leftPinnedRects = leftPinnedElement[gridNo ? gridNo : 0].getBoundingClientRect();
      var leftPos = agWrapper[gridNo ? gridNo : 0].getBoundingClientRect();

      var constantleft = leftPinnedRects.width + leftPos.left;
      var style = "left:" + constantleft + "px;"
      return style;
    }

  }
  setRightShadow(gridNo: number): string {
    var rightPinnedElement = this.getGridElements("ag-pinned-right-cols-viewport");
    if (rightPinnedElement) {
      var rightPinnedRects = rightPinnedElement[gridNo ? gridNo : 0].getBoundingClientRect();
      var constantRight = rightPinnedRects.width + 49;
      var style = "right:" + constantRight + "px;"
      return style;
    }

  }

  setHeight(gridNo: number) {
    var gridIndex = gridNo ? gridNo : 0;
    var header = this.getGridElement("ag-header-container", gridIndex);
    var body = this.getGridElement("ag-body-container", gridIndex);
    var viewPort = this.getGridElement("ag-body-viewport", gridIndex);

    if (!header || !body || !viewPort) {
      return;
    }

    var hederRects = header.getBoundingClientRect();
    var bodyHeight = body.clientHeight;
    var viewPortHeight = viewPort.clientHeight;
    var style = "";

    if (bodyHeight < viewPortHeight) {
      style = "height:" + bodyHeight + "px;"
    }
    else {
      style = "height:" + viewPortHeight + "px;"
    }
    var headerHeight = hederRects.top + hederRects.height;
    var topStyle = "top:"+ headerHeight + "px;"
    var customLeft = style + this.setLeftShadow(gridNo) + topStyle;
    var customRight = style + this.setRightShadow(gridNo) + topStyle;
    if(gridNo){
      if(gridNo == 0){
        var scrollArea0 = this.getHostElement("scroll-area", 0) as HTMLElement;
        var scrollArea1 = this.getHostElement("scroll-area", 1) as HTMLElement;

        if (!scrollArea0 || !scrollArea1) {
          return;
        }

        scrollArea0.setAttribute("style", customLeft);
        scrollArea1.setAttribute("style", customRight);
      }
      if(gridNo == 1){
        var scrollArea2 = this.getHostElement("scroll-area", 2) as HTMLElement;
        var scrollArea3 = this.getHostElement("scroll-area", 3) as HTMLElement;

        if (!scrollArea2 || !scrollArea3) {
          return;
        }

        scrollArea2.setAttribute("style", customLeft);
        scrollArea3.setAttribute("style", customRight);
      }
    }
    else{
      var scrollArea0 = this.getHostElement("scroll-area", 0) as HTMLElement;
      var scrollArea1 = this.getHostElement("scroll-area", 1) as HTMLElement;

      if (!scrollArea0 || !scrollArea1) {
        return;
      }

      scrollArea0.setAttribute("style", customLeft);
      scrollArea1.setAttribute("style", customRight);
    }
  }



  private getGridElement(className: string, index: number = 0): HTMLElement {
    return this.getHostElement(className, index);
  }

  private getGridElements(className: string): HTMLCollectionOf<Element> {
    return this.hostElement.nativeElement.getElementsByClassName(className);
  }

  private getHostElement(className: string, index: number = 0): HTMLElement {
    return this.getGridElements(className)[index] as HTMLElement;
  }
}
